import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "search-results"
}
const _hoisted_3 = { class: "results-list" }
const _hoisted_4 = { class: "label-category" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "search-options" }
const _hoisted_8 = { class: "checkbox-item" }
const _hoisted_9 = {
  class: "checkbox-label",
  for: "filter-stamps-1"
}

import { computed, reactive, watch } from "vue";
  import apiClient from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

  const state = reactive({
    isShowSearchInput: false,
    isVisibleSearchResults: false,
    searchString: "",
    includePast: false,
    timerId: null as null | number,
    filterTimerId: null as null | number,
    lastResponse: null as null | number,
    data: []
  });

  const auctionStore = useAuctionStore();
  const resultUrl = computed(() => auctionStore.routes["site.lots.show_catalog"]);
  const autocompleteUrl = computed(() => auctionStore.routes["site.search.autocomplete"]);

  const resultHref = computed(() => {
    const url = new URL(resultUrl.value, window.location.origin);

    if (state.searchString?.length) {
      url.searchParams.set("searchText", state.searchString);
    } else {
      url.searchParams.delete("searchText");
    }
    url.searchParams.set("auctionStatus", state.includePast ? "past" : "upcoming");
    url.searchParams.set("sortBy", "auction_date");

    return url.toString();
  });

  watch(
    () => state.searchString,
    (nv) => {
      if (state.timerId) {
        clearTimeout(state.timerId);
      }

      if (nv && nv.length >= 1) {
        state.timerId = setTimeout(autocomplete, 600);
      }
    }
  );

  const clickToIcon = () => {
    if (state.searchString && state.searchString.length >= 2) {
      search();
    } else {
      state.isVisibleSearchResults = false;
      state.isShowSearchInput = !state.isShowSearchInput;
    }
  };

  const autocomplete = () => {
    const time = Date.now();
    state.lastResponse = time;
    const queryParam = new URLSearchParams({
      auctionStatus: state.includePast ? "past" : "upcoming",
      q: state.searchString
    });
    apiClient
      .get(`${autocompleteUrl.value}?${queryParam}`)
      .then((response) => {
        if (state.lastResponse <= time) {
          state.data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const clearText = () => {
    state.searchString = "";
    state.showResultsBlock = false;
    state.data = [];
  };

  const search = () => {
    if (state.searchString && state.searchString.length >= 1) {
      window.location = resultHref.value as any;
    }
  };

  const showResultsBlock = () => {
    state.isVisibleSearchResults = true;
  };

  const closeResultsBlock = () => {
    state.isVisibleSearchResults = false;

    if (!state.searchString?.length) {
      state.isShowSearchInput = false;
    }
  };

  const selectSuggestion = (text: string) => {
    state.searchString = text;
    search();
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      action: "#",
      class: _normalizeClass([_ctx.$attrs.class, { show: state.isShowSearchInput }]),
      onSubmit: _withModifiers(search, ["prevent"]),
      onKeyup: _withKeys(search, ["enter"])
    }, [
      _createElementVNode("button", {
        onClick: _withModifiers(clickToIcon, ["prevent"]),
        type: "submit",
        class: "search-submit show"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("svg", { class: "icon-search" }, [
          _createElementVNode("use", { href: "/sprite.svg#search" })
        ], -1)
      ])),
      _createElementVNode("button", {
        class: _normalizeClass(['search-submit clear', { show: state.searchString && state.searchString.length > 0 }]),
        onClick: _withModifiers(clearText, ["prevent"])
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "icon-custom-close" }, [
          _createElementVNode("span", { class: "close-row" }),
          _createElementVNode("span", { class: "close-row" })
        ], -1)
      ]), 2),
      _withDirectives(_createElementVNode("input", {
        onClick: showResultsBlock,
        class: "search-input input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.searchString) = $event)),
        type: "text",
        placeholder: _unref(trans)('header.search.placeholder')
      }, null, 8, _hoisted_1), [
        [_vModelText, state.searchString]
      ]),
      (state.isVisibleSearchResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(trans)("header.search.suggestion")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.categories, (key, text) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `${key}-${text}`,
                  class: "search-item",
                  onClick: ($event: any) => (selectSuggestion(text))
                }, _toDisplayString(text), 9, _hoisted_5))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.tags, (key, text) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `${key}-${text}`,
                  class: "search-item",
                  onClick: ($event: any) => (selectSuggestion(text))
                }, _toDisplayString(text), 9, _hoisted_6))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox-input",
                  type: "checkbox",
                  id: "filter-stamps-1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.includePast) = $event))
                }, null, 512), [
                  [_vModelCheckbox, state.includePast]
                ]),
                _createElementVNode("label", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(trans)("header.search.include_past_auctions")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 34),
    _withDirectives(_createElementVNode("div", {
      class: "modal-overlay",
      onClick: closeResultsBlock
    }, null, 512), [
      [_vShow, state.isVisibleSearchResults]
    ])
  ], 64))
}
}

})